export const getBrand = (state) => state.getIn(['page', 'brand']);
export const getBrandingServiceUrl = (state) => state.getIn(['serverConfig', 'brandingServiceBaseUrl']);
export const getEnv = (state) => state.getIn(['serverConfig', 'env']);
